// Is WhatsApp sending? One read of whatsapp_status() (mig 20261038400000), the
// same function the edge sender reads.
//
// FAIL-CLOSED: while the read is in flight, after it fails, or when it answers
// in a shape this app does not know, `paused` is TRUE. The sender fails closed
// the same way, so "paused" is the only claim that is safe to make without an
// answer — a screen must never imply a WhatsApp went out because it could not
// tell otherwise.

import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { withReadTimeout } from '@/lib/saveTimeout'
import { parseWhatsAppStatus, WHATSAPP_PAUSED, type WhatsAppStatus } from '@/lib/whatsappStatus'

export interface UseWhatsAppStatus extends WhatsAppStatus {
  /** 'ready' = the answer came back; otherwise `paused` is the fail-closed default. */
  state: 'loading' | 'error' | 'ready'
}

export function useWhatsAppStatus(): UseWhatsAppStatus {
  // rpc-tenant-key-ignore whatsapp_status() reads the platform's ONE settings
  // row (platform_whatsapp_settings): the same answer for every tenant.
  const q = useQuery({
    queryKey: ['whatsapp-status'],
    staleTime: 5 * 60_000,
    retry: 1,
    queryFn: async (): Promise<WhatsAppStatus> => {
      const { data, error } = await withReadTimeout(supabase.rpc('whatsapp_status'), 'WhatsApp status')
      if (error) throw error
      return parseWhatsAppStatus(data)
    },
  })
  if (q.data !== undefined) return { ...q.data, state: 'ready' }
  return { ...WHATSAPP_PAUSED, state: q.isError ? 'error' : 'loading' }
}
